import type { AdjustmentReason } from '../../services/broadcastAdminService'

/**
 * Shared by BroadcastEntitlement and BroadcastEntitlementForms.
 *
 * Lives in its own module to break a circular import: the forms needed REASONS
 * from the parent while the parent imported the forms. Whichever evaluated
 * second got partially-initialised bindings, so the parent could render
 * `undefined` as a component — React throws "Element type is invalid", the
 * router error boundary catches it, and NotFoundPage renders. A 404 that was
 * never an HTTP 404.
 */
export const REASONS: { value: AdjustmentReason; label: string; hint: string }[] = [
  { value: 'degraded_content', label: 'Degraded content', hint: 'rain delay, long stoppage, mostly non-game footage' },
  { value: 'failed_analysis', label: 'Failed analysis', hint: 'the run failed on our side' },
  { value: 'goodwill', label: 'Goodwill', hint: 'commercial gesture' },
  { value: 'correction', label: 'Correction', hint: 'fixing a mistaken charge' },
  { value: 'promotional', label: 'Promotional', hint: 'trial or marketing credits' }
]
